<script>
	// const _ = require('underscore');
	const model = require('model/model');
	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const ONBOARDING = analyticsUtilities.events.ONBOARDING;
	const page = require('page');
	const classService = require('services/classService');
	const accountService = require('services/accountService');
	const userContext = require('core/userContext');
	const Q = require('q');
	const stringUtilities = require('utilities/stringUtilities');

	const textareaPlaceholder =
		'Type or copy and paste each student on a new line.<br /><br />Example:<br /><br />Adam Smith<br />Harriet Tubman<br />Alexander Hamilton<br />Shel Silverstein<br />Eleanor Roosevelt<br />Italo Calvino';

	module.exports = {
		components: {
			'validated-textarea': require('components/validated-textarea.vue').default,
			'validated-form': require('components/validated-form.vue').default
		},
		modelData: ['userContext', 'onboardingClassData'],
		data() {
			return {
				classType: '',
				textareaPlaceholder,
				studentText: '',
				loading: false
			};
		},
		computed: {
			grade() {
				let classData = this.onboardingClassData;
				return classData.grade;
			},
			className() {
				let classData = this.onboardingClassData;
				return classData.name;
			}
		},
		methods: {
			eventClick(action_type) {
				let data = {
					step: 'add-students',
					action_type
				};
				fireEvent(ONBOARDING, data);
			},
			createClass(rosterType) {
				let name = this.className;
				let grade = String(this.grade);
				let goals = this.onboardingClassData.goals;
				let students = [];
				let cc = null;

				if (rosterType === 'teacher') {
					students = this.studentText.split('\n').filter(v => v.trim());
				}
				this.loading = true;

				return classService
					.createClass({
						n: name,
						g: grade,
						rt: rosterType
					})
					.then(result => {
						let prms = Q();
						cc = result && result.cc ? result.cc : null;
						userContext.setToken(result.token);

						if (rosterType === 'teacher' && students.length) {
							prms = accountService.createTeacherRosteredStudents({
								cc,
								students
							});
						}
						return prms;
					})
					.then(result => {
						let prms = Q();

						if (goals && goals.length) {
							prms = classService.assignmentSettings({ cc: cc, goals });
						}

						return prms;
					})
					.then(result => {
						model.remove('onboardingClassData');
						model.set('classType', this.classType);
						model.set('classCode', cc);
						model.set('className', name);
						page(`/class-admin#!classAdmin:roster/classCode:${cc}`);
					})
					.finally(() => (this.loading = false));
			},
			onTeacherRosterClick() {
				this.classType = 'teacher';
			},
			onGoogleRosterClick() {
				this.classType = 'student';
				this.createClass(this.classType);
			},
			setStudentText(event) {
				this.studentText = stringUtilities.stripHTML(event.target.value);
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';

	.onboarding-add-students {
		.add-students-content {
			.one-option {
				font-size: 0.75rem;
			}

			.roster-type-selector {
				display: block;
				margin: 2rem;

				.roster-separator {
					flex: 1;
					text-align: center;
					margin: 2rem;
					display: flex;
					align-items: center;
					justify-content: center;
				}

				.roster-panel {
					flex: 10;
					margin: 0 auto;
				}
			}

			.add-students-form {
				.roster-panel {
					margin: 0 auto 1rem auto;

					.student-text {
						height: 18rem;
						width: 100%;

						textarea {
							border: 1px solid transparent;
						}
					}
				}
			}
		}
	}

	@media only screen and (min-width: $bp-width-med) {
		.onboarding-add-students .add-students-content .roster-type-selector {
			display: flex;
		}
	}
</style>
<template>
	<main
		id="content"
		class="main onboarding-add-students onboarding">
		<header class="onboarding-header">
			<div class="wrapper">
				<a
					href="/onboarding-class-name"
					class="back-nav"
					@click="eventClick('back')">
					<i
						class="fa-solid fa-chevron-left"
						aria-hidden="true"></i>
					{{ className }}, {{ [grade] | getGradeRangeWithOrdinal }} grade
				</a>
				<div class="account-name">{{ userContext.email }}</div>
			</div>
		</header>
		<div class="main-content wrapper">
			<section>
				<h2 class="panel-title">Great. Let's invite students to the {{ className }} class.</h2>
				<div class="add-students-content">
					<div
						v-if="!classType || classType === 'student'"
						class="one-option text-muted">
						Only one option can be selected.
					</div>
					<div
						v-if="!classType || classType === 'student'"
						class="roster-type-selector">
						<div class="roster-panel student-roster-panel">
							<div class="roster-panel-title">Google Sign In</div>
							<div class="roster-panel-body">
								<ol class="roster-panel-list">
									<li>Students sign in with their own Google account.</li>
									<li>Students access this class using a class code you give them.</li>
								</ol>
								<div class="button-container">
									<button
										type="button"
										class="button invite-with-google"
										@click="onGoogleRosterClick"
										:class="{
											'-in-progress': loading
										}"
										:disabled="loading">
										Invite with Google
									</button>
								</div>
							</div>
						</div>
						<div class="roster-separator">OR</div>
						<div class="roster-panel teacher-roster-panel">
							<div class="roster-panel-title">Roster</div>
							<div class="roster-panel-body">
								<ol class="roster-panel-list">
									<li>You add the students' names to the roster.</li>
									<li>Students access this class using a class code, and select their name.</li>
								</ol>
								<div class="button-container">
									<button
										type="button"
										class="button"
										:class="{
											'-in-progress': loading
										}"
										:disabled="loading"
										@click="onTeacherRosterClick">
										Invite with roster
									</button>
								</div>
							</div>
						</div>
					</div>
					<validated-form
						v-if="classType === 'teacher'"
						class="add-students-form"
						ref="form"
						@submit.native.prevent="createClass('teacher')">
						<div class="roster-panel">
							<div class="roster-panel-title">Add Students</div>
							<div class="roster-panel-body">
								<validated-textarea
									class="student-text"
									@input.native="setStudentText"
									:value="studentText"
									:placeholder="textareaPlaceholder"
									:hide-message-bar="true">
								</validated-textarea>
							</div>
						</div>
						<div class="input-wrapper submit-wrapper">
							<button
								type="submit"
								class="button submit"
								:class="{
									'-in-progress': loading
								}"
								:disabled="!(className && grade && studentText) || loading">
								Create Class
							</button>
						</div>
					</validated-form>
				</div>
				<a
					href="/find-content"
					class="take-me-to-search text-muted"
					@click="eventClick('search')">
					Take me to search
				</a>
			</section>
		</div>
	</main>
</template>
